var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubtract = function SvgSubtract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.7778 9.33334H4.88889C4.39797 9.33334 4 9.73131 4 10.2222V19.1111C4 19.602 4.39797 20 4.88889 20H13.7778C14.2687 20 14.6667 19.602 14.6667 19.1111V10.2222C14.6667 9.73131 14.2687 9.33334 13.7778 9.33334Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.2222 4H19.1111C19.602 4 20 4.39797 20 4.88889V13.7778C20 14.2687 19.602 14.6667 19.1111 14.6667H15.5555V10.2222C15.5555 9.24038 14.7596 8.44444 13.7778 8.44444H9.33331V4.88889C9.33331 4.39797 9.73128 4 10.2222 4ZM14.6666 14.6667H10.2222C9.73128 14.6667 9.33331 14.2687 9.33331 13.7778V9.33333H13.7778C14.2687 9.33333 14.6666 9.7313 14.6666 10.2222V14.6667Z",
    clipRule: "evenodd"
  })));
};
export default SvgSubtract;